<template>
  <base-layout>
    <template #header>
      <dot-header />
    </template>
    <template #default>
      <router-view />
    </template>
    <template #footer>
      <dot-footer />
    </template>
  </base-layout>
</template>

<script setup lang="ts">
import BaseLayout from "@/layouts/template/BaseLayout.vue";
import DotHeader from "@/layouts/inc/Header.vue";
import DotFooter from "@/layouts/inc/Footer.vue";
</script>

<style scoped></style>
